import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { onMounted, ref } from 'vue';
import { useInboxStore } from '@dashboardApp/stores/InboxStore';
import DatedMessagesMobile from '@dashboardApp/components/inbox/DatedMessagesMobile.vue';
export default {
  __name: 'ViewThreadMobile',
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose;
    /**
     * Note: Fetching of thread done in views/inbox/Inbox.vue
     */
    var inboxStore = useInboxStore();
    var datedMessagesEl = ref(null);
    var scrollEl = ref(null);
    onMounted(function () {
      scrollEl.value = datedMessagesEl.value.messagesScrollEl;
    });
    __expose({
      scrollEl: scrollEl
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(DatedMessagesMobile, {
        ref_key: "datedMessagesEl",
        ref: datedMessagesEl,
        "grouped-messages": _unref(inboxStore).datedMessages,
        hasThreadMessages: _unref(inboxStore).hasThread,
        from: _unref(inboxStore).from,
        "thread-id": _unref(inboxStore).threadId,
        "is-archived": _unref(inboxStore).isArchived,
        "with-reply": _ctx.$route.hash == '#reply',
        isLoading: _unref(inboxStore).threadIsLoading,
        isInitiallyLoading: _unref(inboxStore).threadIsLoading && !_unref(inboxStore).hasThread
      }, null, 8, ["grouped-messages", "hasThreadMessages", "from", "thread-id", "is-archived", "with-reply", "isLoading", "isInitiallyLoading"]);
    };
  }
};